import { render } from "./flats-crm-filter.vue?vue&type=template&id=6f97ee51"
import script from "./flats-crm-filter.vue?vue&type=script&lang=js"
export * from "./flats-crm-filter.vue?vue&type=script&lang=js"

import "./flats-crm-filter.vue?vue&type=style&index=0&id=6f97ee51&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__